import React from "react";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import OwlCarousel from "react-owl-carousel";
import ProductItem from "./ProductItem";

const ProductCarousel = ({ products }) => {
  const options = {
    //loop: true,
    rewind: true,
    autoplay: false,
    margin: 20,
    responsive: {
      responsiveRefreshRate: 100,
      0: {
        items: 1,
      },
      400: {
        items: 2,
      },
      600: {
        items: 3,
      },
      850: {
        items: 4,
      },
      1050: {
        items: 5,
      },
    },
  };

  const pro = products.map((item, index) => {
    const item1 = {};
    item1.image = item.url;

    return <ProductItem product={item1} key={index.toString()} />;
  });

  return (
    <OwlCarousel className="owl-theme owl-app-frame" {...options}>
      {pro}
    </OwlCarousel>
  );
};

export default ProductCarousel;



// WEBPACK FOOTER //
// ./components/product/index.js